import { Stack } from '@mui/material';
import { Trans, useLingui } from '@lingui/react/macro';

import { routeForLearningHub } from '@watershed/shared-universal/dashboardRoutes';
import HomeCardBase from './HomeCardBase';
import flagGreen from './flag-green.png';
import netZero from './net-zero.png';
import LightBulbIcon from '@watershed/icons/components/LightBulb';
import WellExternalLink from '@watershed/ui-core/components/WellExternalLink';

export default function KickoffCard() {
  const { t } = useLingui();
  return (
    <HomeCardBase
      title={{ label: t`Learning hub`, icon: LightBulbIcon }}
      link={{
        to: routeForLearningHub({ from: 'HomePage' }),
        label: t`Learn more`,
        event: 'homeLearningHubButton',
      }}
    >
      <Stack p={2}>
        <WellExternalLink
          src={flagGreen.src}
          title={<Trans>Building a world class climate program</Trans>}
          description={
            <Trans>
              Learn about the four key steps of building a top-tier corporate
              sustainability program for tackling climate change: measuring
              emissions, reducing them with initiatives, achieving net zero, and
              reporting progress.
            </Trans>
          }
          href="https://watershed.com/blog/building-a-world-class-climate-program"
        />
        <WellExternalLink
          gradient="green"
          src={netZero.src}
          title={<Trans>What is net zero and how do you achieve it?</Trans>}
          description={
            <Trans>
              Learn about the need for balancing emitted and removed greenhouse
              gases by 2050, a critical target for all businesses in the wider
              effort to avert severe climate change.
            </Trans>
          }
          href="https://watershed.com/blog/a-standard-for-net-zero"
        />
      </Stack>
    </HomeCardBase>
  );
}
